<label for="{{ $label() }}" class="label">{{ $label() }}</label>
@if (controlDir && controlDir.control && controlDir.control.touched && !controlDir.control.valid) {
<div class="error-message">
  @if ($form()?.controls?.email) { @if ($form()?.controls?.email?.errors?.validateEmail && $label() === 'Email Address')
  {
  <p>ONEOK employee's must use the employee login link at the bottom of the form</p>
  } @if ($form()?.controls?.email?.errors?.pattern && $label() === 'Email Address*') { } @if
  ($form()?.controls?.email?.errors?.pattern && $label() === 'Email Address*') {
  <p>This email address entered is not valid</p>
  } } @if ($form()?.controls?.mobile) { @if ($form()?.controls?.mobile?.errors?.pattern && $label() === 'Mobile*') { } }
  @if ($form()?.controls?.mobile) { @if ($form()?.controls?.mobile?.errors?.pattern && $label() === 'Mobile*') {
  <p>The mobile number entererd is not valid</p>
  }
  <p>{{ $label() | removeAsterisk }} is a required field</p>

  }
</div>
}
<input
  #input
  id="{{ $label() }}"
  placeholder="{{ $label() | removeAsterisk }}.."
  class="input input--text mb-3"
  [type]="$type()"
  [class]="controlDir && controlDir.control && controlDir.control.touched ? (!controlDir.control.valid ? 'is-invalid' : 'is-valid') : null"
  (input)="onChangeValue($any($event.target).value)"
  (blur)="onTouchedValue()"
/>
